<template>
  <div class="menu-box">
    <div v-for="(item, idx) in config" :key="idx" @click="redirect(item.path)">
      {{item.name}}
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      config: {
        type: Array,
        default: () => []
      },
    },
    methods: {
      redirect(path) {
        this.$router.push(path);
      }
    },
  }
</script>
<style lang="less" scoped>
@import url('~@/assets/styles/vars.less');
.menu-box {
  width: 200px;
  flex-shrink: 0; 
}
</style>